// extracted by mini-css-extract-plugin
export default {"overlay":"Reschedule-module__overlay--0-Oqi","iconClose":"Reschedule-module__iconClose--LZngE","dialog":"Reschedule-module__dialog--OEMF9"};